import { Component } from "@angular/core";
import { AppService } from "../app.service";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: "app-interactions",
  standalone: false,
  templateUrl: "./interactions.component.html",
  styleUrls: ["./interactions.component.css"],
})
export class InteractionsComponent {
  displayedColumns: string[] = [
    "accountHolder",
    "transaction",
    "terminalName",
    "intentionPrimary",
    "additionalParameters",
  ];
  interactions: any = [];
  apiKey: any;
  showErrorMsg: boolean = false;
  showErrorText: any;
  status: any;
  csummery: any;
  workspaceName: any;
  institutionName: any;
  txt: any;
  selected = new FormControl("valid", [
    Validators.required,
    Validators.pattern("valid"),
  ]);
  loading = true;

  constructor(
    public appService: AppService,
    public router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.getConnectorSummary();
    this.getInteractions();
  }

  formatTimeStamp(ts: number): string {
    const timestamp = ts * 1000;
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  async copyMessage(message: string) {
    try {
      await navigator.clipboard.writeText(message);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

async getConnectorSummary() {
    
    try {

      let activationPayload: any = {
        routeType:"UI_SESSION"
      };
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.status = ws.status;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      } 

    const signatureData = await this.appService.wssign(
    activationPayload,
      this.workspaceName
    );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
      activationPayload,
      "usage/connector-summary",
      this.apiKey,
      signature
    );

    if (response && response.status == "Success") {
      this.txt = response.message;
      // this.appService.addSuccessMessage(this.txt);
    }
    
    } catch (error: any) {
      this.txt = "Activation failed: " + (error.message || "Unknown error");
    }

  }

  async getInteractions() {
    try {
      const wsJson = this.appService.get("xdbc.workspace");


      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.workspaceName = ws.workspaceName;
          this.institutionName = ws.institutionName;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      } 

      if (this.status === "ACTIVATED") {
        this.showErrorMsg = false;
      } else {
        this.showErrorMsg = true;
        this.showErrorText =
          "The selected workspace is currently inactive. Please activate it to proceed.";
      }

      let terminal =
        "TERMINAL:" + this.workspaceName + ":" + this.institutionName;

      const activationPayload = {
        userKey: "",
        searchKey: terminal.toUpperCase(),
        offset: 1,
        max: 100,
        routeType:"UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "knowledge/interactions",
        this.apiKey,
        signature
      );
      this.loading = false;
      if (response && response.status == "Success") {
        this.interactions = response;
        this.txt = response.message;
        // this.appService.addSuccessMessage(this.txt);
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in submitPrivateKey:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
      // this.appService.addErrorMessage(
      //   "Failed to activate connector: " + (error.message || "Unknown error")
      // );
    }
  }
}
